export enum AssetSubStatus {
  Disabled = -1,
  NoSubStatus = 0,
  Revision = 101,
  Storm = 102,
  Malfunction = 103,
  Circulation = 201,
  Convoy = 202,
}
